import {Component, OnInit} from '@angular/core';
import {Compbaser} from "../../../components/compbaser";
import {animate, style, transition, trigger} from "@angular/animations";
import {ChildrenOutletContexts} from '@angular/router';
import {Memoizee} from "../../../decorators/memoizee-decorator";

@Component({
  selector: 'app-started-entry',
  templateUrl: './started-entry.component.html',
  animations: [
    trigger('fadeIn', [
      transition('* => *', [
        style({opacity: 0}),
        animate('300ms ease-in-out')
      ])
    ])
  ]
})

export class StartedEntryComponent extends Compbaser implements OnInit {

  constructor(private contexts: ChildrenOutletContexts) {
    super();
  }

  ngOnInit() {
  }

  @Memoizee({})
  getState() {
    return this.contexts.getContext('primary')?.route?.snapshot?.data?.['state'];
  }
}
